import { AnyAction, combineReducers } from '@reduxjs/toolkit';
import composableFiltersState from './composableFiltersSlice';
import { segmentsApi } from './services/segmentsApi';
import productMeta from './useProductMetaSlice';
import userDetails, { logout } from './userDetailsSlice';

const appReducer = combineReducers({
  userDetails,
  composableFiltersState,
  productMeta,
  [segmentsApi.reducerPath]: segmentsApi.reducer,
});

const rootReducer = (state: any, action: AnyAction) => {
  if (logout.match(action)) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
